"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _styles = require("@material-ui/core/styles");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _camelCase2 = _interopRequireDefault(require("../poly/camelCase"));
var _excluded = ["className", "children", "color", "variant", "gutters", "transparent"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var COLOR_TYPES = ['primary', 'secondary', 'tertiary'];
var GUTTER_TYPES = ['page', 'condensed', 'navigation'];
var buildBoxVariantStyles = function buildBoxVariantStyles(color, _ref) {
  var palette = _ref.palette;
  return (0, _defineProperty2.default)({}, (0, _camelCase2.default)(['color', color]), (0, _extends2.default)({}, palette.box.default[color]));
};
var buildBoxGutters = function buildBoxGutters(gutter, _ref3) {
  var _camelCase;
  var breakpoints = _ref3.breakpoints,
    gutters = _ref3.gutters;
  return (0, _defineProperty2.default)({}, (0, _camelCase2.default)(['gutters', gutter]), (_camelCase = {
    paddingLeft: gutters.box[gutter].xs,
    paddingRight: gutters.box[gutter].xs
  }, (0, _defineProperty2.default)(_camelCase, breakpoints.up('sm'), {
    paddingLeft: gutters.box[gutter].sm,
    paddingRight: gutters.box[gutter].sm
  }), (0, _defineProperty2.default)(_camelCase, breakpoints.up('md'), {
    paddingLeft: gutters.box[gutter].md,
    paddingRight: gutters.box[gutter].md
  }), (0, _defineProperty2.default)(_camelCase, breakpoints.up('lg'), {
    paddingLeft: gutters.box[gutter].lg,
    paddingRight: gutters.box[gutter].lg
  }), (0, _defineProperty2.default)(_camelCase, breakpoints.up('xl'), {
    paddingLeft: gutters.box[gutter].xl,
    paddingRight: gutters.box[gutter].xl
  }), _camelCase));
};
var useClasses = (0, _styles.makeStyles)(function (theme) {
  return (0, _extends2.default)({
    root: {
      color: 'inherit'
    }
  }, COLOR_TYPES.reduce(function (colorStyles, color) {
    return (0, _extends2.default)({}, colorStyles, color ? buildBoxVariantStyles(color, theme) : {});
  }, {}), GUTTER_TYPES.reduce(function (gutterStyles, gutter) {
    return (0, _extends2.default)({}, gutterStyles, !!gutter ? buildBoxGutters(gutter, theme) : {});
  }, {}), {
    transparent: {
      background: 'transparent'
    }
  });
}, {
  classNamePrefix: 'TCUIBox'
});
var Box = /*#__PURE__*/(0, _react.forwardRef)(function (_ref5, ref) {
  var _clsx;
  var className = _ref5.className,
    children = _ref5.children,
    color = _ref5.color,
    variant = _ref5.variant,
    gutters = _ref5.gutters,
    transparent = _ref5.transparent,
    rest = (0, _objectWithoutProperties2.default)(_ref5, _excluded);
  var _classes = useClasses();
  return /*#__PURE__*/_react.default.createElement(_Box.default, (0, _extends2.default)({}, rest, {
    ref: ref,
    className: (0, _clsx2.default)(_classes.root, (_clsx = {}, (0, _defineProperty2.default)(_clsx, _classes.transparent, transparent), (0, _defineProperty2.default)(_clsx, _classes[(0, _camelCase2.default)(['variant', variant])], !!variant), (0, _defineProperty2.default)(_clsx, _classes[(0, _camelCase2.default)(['gutters', gutters])], !!gutters && gutters !== 'none'), (0, _defineProperty2.default)(_clsx, _classes[(0, _camelCase2.default)(['color', color])], !!color), _clsx), className)
  }), children);
});
Box.propTypes = {
  transparent: _propTypes.default.bool,
  variant: _propTypes.default.oneOf(['contained']),
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  color: _propTypes.default.oneOf(COLOR_TYPES),
  gutters: _propTypes.default.oneOf([].concat(GUTTER_TYPES, ['none']))
};
Box.defaultProps = {
  transparent: false,
  variant: null,
  className: null,
  children: null,
  color: null,
  gutters: null
};
var _default = Box;
exports.default = _default;